export const ChatBg = '../assets/images/chatdefaultbg.svg';
export const CloseButton = '../assets/svg/close.svg';
export const SUN = '../assets/svg/Sun.svg';
export const MOON = '../assets/svg/Moon.svg';
export const Message_bold = '../assets/svg/message-bold.svg';
export const Message_outline = '../assets/svg/message-outline.svg';
export const Group = '../assets/svg/group.svg';
export const Message_Add = '../assets/svg/message-add.svg';
export const Login_banner ='../assets/svg/login.svg'
export const Broadcast_bold = '../assets/svg/broadcast-selected.svg';
export const Broadcast_outline = '../assets/svg/broadcst-default.svg';
export default { ChatBg,Login_banner,CloseButton,SUN,MOON,Message_bold,Message_outline,Group,Message_Add };